import React, { Component } from 'react';
import API from '../../services/API';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import OffersTable from './components/OffersTable';
import Form from './components/Form';

class BidderManualOffers extends Component {
    constructor() {
        super();

        this.state = {
            offers: [],
            isLoading: false,
            isShowForm: false,
            selectedOffer: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleDuplicate = this.handleDuplicate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadOffers();
    }

    loadOffers() {
        this.setState({ isLoading: true });

        API.BidderManualOffers.get()
            .then(({ offers }) => this.setState({ offers,  isLoading: false }));
    }

    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    offer={this.state.selectedOffer}
                />
            );
        }
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedOffer: null,
            action: 'save'
        });
    }

    handleUpdate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'update'
        });
    }

    handleDuplicate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'save'
        });
    }

    handleRemove(offerID) {
        this.setState({
            isLoading: true
        });

        API.BidderManualOffers.remove(offerID).then(() => {
            let { offers } = this.state;
            offers = offers.filter(item => !(item.id === offerID));


            this.setState({
                isLoading: false,
                offers
            });
        });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder'], 'manualOffers', 8081)
            .then(() => this.setState({ isLoading: false }));
    }

    handleFormHide() {
        this.setState({
            isShowForm: false
        });
    }

    handleFormSubmit({ id, ...offer }) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(this.state.action === 'update') {
            API.BidderManualOffers.update(id, offer).then(() => this.loadOffers());
        }
        else {
            API.BidderManualOffers.save(offer).then(() => this.loadOffers());
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Manual Offers"/>

                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                        <Button className="pull-right m-b-15 m-r-15" bsStyle="info" onClick={this.handleSync}> Sync</Button>
                    </Col>
                </Row>
                {this.getForm()}
                <OffersTable
                    offers={this.state.offers}
                    onUpdate={this.handleUpdate}
                    onDuplicate={this.handleDuplicate}
                    onRemove={this.handleRemove}
                />
            </Container>
        );
    }
}

export default BidderManualOffers;


// WEBPACK FOOTER //
// ./src/scenes/BidderManualOffers/index.js